import React from "react";
import styled from "styled-components";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useTranslation } from "react-i18next";

const Top10ProductsByAmount = ({ topProductsByAmount }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardTitle>{t("top_10_products_amount")}</CardTitle>
      <ChartContainer>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={topProductsByAmount}
            layout="vertical"
            margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
            barCategoryGap={8}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis
              dataKey="name"
              type="category"
              tick={{ fontSize: 12 }}
              width={90}
              interval={0}
              tickLine={false}
              style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
              tickFormatter={(value) => {
                const split = value.split(" ");
                if (split.length > 2) {
                  return `${split[0]} ${split[1]}...`;
                }
                return value;
              }}
            />
            <Tooltip formatter={(value, name) => [`${value} ${t("pieces").toLowerCase()}`, t("amount_sold")]} />
            <Legend />
            <Bar dataKey="totalQuantity" name={t("amount_sold")} fill="#938370" />
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
    </Card>
  );
};

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const ChartContainer = styled.div`
  height: 24rem;
`;

export default Top10ProductsByAmount;
